var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"has-text-weight-bold",class:_vm.presenter.indicatorClass},[_vm._v(" "+_vm._s(_vm.presenter.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }